import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_ORDER_CONFIRMATION_RECIPIENTS } from './gql/getOrderConfirmationRecipients';

type QueryDataType = Pick<Query, 'getOrderConfirmationRecipients'>;
type OutgoingDataType = QueryDataType['getOrderConfirmationRecipients'];

const onError = getErrorLoggerFunction('getOrderConfirmationRecipients');

export const useGetOrderConfirmationRecipients = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_ORDER_CONFIRMATION_RECIPIENTS, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getOrderConfirmationRecipients);
        }
    }, [data]);

    return {
        orderConfirmationRecipients: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
